import { FC, ReactNode, useContext } from 'react';
import { Text, Button, Stack, BoxProps } from '@mantine/core';

import AuthContext from 'context/AuthContext';
import BillingContext from 'context/BillingContext';
import { AccessLevel } from 'interfaces/GetUserResult';
import Overlay from 'components/Overlay';

import classes from './UpgradeOverlay.module.scss';

interface UpgradeOverlayProps extends BoxProps {
  children: ReactNode;
}

const UpgradeOverlay: FC<UpgradeOverlayProps> = ({
  children,
  ...containerProps
}) => {
  const {
    data: { account },
  } = useContext(AuthContext);
  const {
    actions: { setPricingOpened },
  } = useContext(BillingContext);
  const isPremium = account?.access_level === AccessLevel.PRO;

  const handleUpgrade = async () => {
    setPricingOpened(true);
  };

  return (
    <Overlay
      showOverlay={!isPremium}
      overlayContent={
        <Stack align="center" justify="center" h="100%" gap="xs" p="xl">
          <Text
            ta="center"
            size="md"
            mb="xs"
            maw={600}
            fw={600}
            className={classes.upgradeText}
          >
            Use AI to maximize customer insights. Unlock full call details,
            transcripts, recordings, and analytics to analyze every conversation
            effortlessly.
          </Text>
          <Button
            size="sm"
            mt="sm"
            color="var(--green-color)"
            onClick={handleUpgrade}
          >
            Upgrade now
          </Button>
        </Stack>
      }
      {...containerProps}
    >
      {children}
    </Overlay>
  );
};

export default UpgradeOverlay;
